
export interface Product {
  id: string;
  category: string;
  icon: string;
  name: string;
  description: string;
  suitableFor: string[];
  availability: string;
  images: string[];
  features?: string[];
  specifications?: Record<string, string>;
}

export const productsData: Product[] = [
  {
    id: 'laser-toner-cartridges',
    category: 'laser-toner-cartridges',
    icon: 'ri-printer-line',
    name: 'Laser Toner Cartridges',
    description:
      'Premium quality compatible laser toner cartridges for HP, Canon, Brother, Samsung, and other major brands. High page yield with crisp, professional prints. Available in various models for all popular printer series.',
    suitableFor: ['Retailer', 'Wholesaler', 'Service Center'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/65c957b2234b116798245ae2845a6a20.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/f351c694e2243f6431cda8ecdcc1ff54.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/74f04ec941e41511590bae2c33ef9c61.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/da16b163cfef730aabaf04e18039b637.jpeg',
    ],
    features: [
      'Compatible with HP, Canon, Brother, Samsung printers',
      'High page yield at 5% coverage',
      'Premium quality toner powder for sharp text',
      'Easy installation with no mess',
      'ISO 9001 certified manufacturing',
    ],
    specifications: {
      'Compatible Brands': 'HP, Canon, Brother, Samsung',
      Color: 'Black',
      Type: 'Compatible',
      Quality: 'Premium Grade',
      Certification: 'ISO 9001',
    },
  },
  {
    id: 'generic-ink',
    category: 'generic-ink',
    icon: 'ri-drop-line',
    name: 'Generic Ink',
    description:
      'High-quality generic refill ink for Epson, HP, Canon, and Brother inkjet printers. Available in Black, Cyan, Magenta, and Yellow. Vibrant colors for photos and sharp text for documents.',
    suitableFor: ['Retailer', 'Wholesaler', 'Service Center'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/51075ca1e04741f03ed7dcf7102cf65c.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/cadf5440e72dc91ceebde0bae774c2f0.png',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/d0d53c50fcf76f12dd29dac0aa41c778.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/2202810b5e2493f9a3926764932e35b4.jpeg',
    ],
    features: [
      'Compatible with Epson, HP, Canon, Brother printers',
      'Available in CMYK colors',
      'Dye-based and pigment-based options',
      'Fade-resistant prints',
      'Easy refill with precision nozzle',
    ],
    specifications: {
      'Compatible Brands': 'Epson, HP, Canon, Brother',
      'Colors Available': 'Black, Cyan, Magenta, Yellow',
      Type: 'Dye-based / Pigment-based',
      Volume: '100ml bottles',
      Quality: 'Premium Grade',
    },
  },
  {
    id: 'gi2-premium-ink',
    category: 'gi2-premium-ink',
    icon: 'ri-ink-bottle-line',
    name: 'Gi2 Premium Ink',
    description:
      'Gi2 Premium Ink (GI-71 Series) — high-quality compatible ink bottles for Canon Pixma G series printers. Available in Black (BK), Yellow (Y), Magenta (M), and Cyan (C). 70ml bottles with vibrant, long-lasting color output and smooth ink flow for consistent printing results.',
    suitableFor: ['Retailer', 'Wholesaler', 'Service Center'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/69ca9293e5e43af0ef63000a847d8c3a.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/59007513ae2cbb61ba4055b2c6e9b523.png',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/aad51b3345c04a6d3d592cb35836dc12.png',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/a5cbe1a229ebea2c1cb03eb0e20e7052.png',
    ],
    features: [
      'Compatible with Epson, Canon, Brother, HP printers',
      'Available in BK, Y, M, C (GI-71 Series)',
      '70ml per bottle for high page yield',
      'Vibrant, fade-resistant color output',
      'Smooth ink flow with no clogging',
    ],
    specifications: {
      'Compatible Printers': 'Epson, Canon, Brother, HP',
      'Colors Available': 'Black, Cyan, Magenta, Yellow',
      'Model Series': 'GI-71 (BK, Y, M, C)',
      Volume: '70ml per bottle',
      Quality: 'Premium Grade',
    },
  },
  {
    id: 'opc-drums',
    category: 'opc-drums',
    icon: 'ri-disc-line',
    name: 'OPC Drums',
    description:
      'High-quality OPC drums compatible with HP, Canon, Brother, and Samsung toner cartridges. Long lifespan with consistent print quality. Premium photosensitive coating reduces print defects and streaking.',
    suitableFor: ['Wholesaler', 'Service Center'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/797a71a03a2b658dd0b2dd38dcaaab2c.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/b4699182e128fd16ed60ee83a3c42891.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/e4f6af204cb510c5a9bca77460736819.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/93e5dbca5c8c10da80b1904d5536a420.jpeg',
    ],
    features: [
      'Compatible with HP, Canon, Brother, Samsung cartridges',
      'Lifespan: 10,000-15,000 pages',
      'Premium photosensitive coating',
      'Reduces print defects and streaking',
      'Easy installation in cartridge',
    ],
    specifications: {
      'Compatible Brands': 'HP, Canon, Brother, Samsung',
      Lifespan: '10,000-15,000 pages',
      Coating: 'Organic Photoconductor',
      Quality: 'Premium Grade',
      Type: 'Compatible',
    },
  },
  {
    id: 'toner-powder',
    category: 'toner-powder',
    icon: 'ri-flask-line',
    name: 'Toner Powder',
    description:
      'Premium grade universal black toner powder for HP, Canon, Brother, and Samsung laser printers. Consistent particle size for smooth printing. Available in bulk quantities for high-volume refilling.',
    suitableFor: ['Wholesaler', 'Service Center'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/8dce46f1217e24fd32de9b0f7ec52472.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/2602fa464e69b4a3bfe1ad287adc756b.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/cc5ce91a58afdd54b8ea759ac11c68e1.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/6c29967faabb54c6f69c5a629a316a27.jpeg',
    ],
    features: [
      'Universal compatibility with HP, Canon, Brother, Samsung',
      'Premium grade toner for sharp, dark prints',
      'Consistent particle size distribution',
      'Low melting point for energy efficiency',
      'Available in various packaging options according to requirements',
    ],
    specifications: {
      'Compatible Brands': 'HP, Canon, Brother, Samsung',
      Color: 'Black',
      'Particle Size': '5-8 microns',
      'Melting Point': '160-180°C',
      'Available Weights': 'On request',
    },
  },
  {
    id: 'lamination-pouch',
    category: 'lamination-pouch',
    icon: 'ri-file-shield-line',
    name: 'Lamination Pouch',
    description:
      'Premium quality lamination pouches in various sizes from ID card to A3. Crystal clear finish for documents, certificates, menus, and presentations. Available in 80, 125, and 250 micron thickness.',
    suitableFor: ['Retailer', 'Wholesaler', 'Corporate'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/57b703ec43ad7d7afc450c9c9deac700.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/9e32b64a69669201ab53f8a180d9d0b5.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/5eb7e43d26228c07d1ee465d13e945a6.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/e7c3c50c6b3cf83a58c8df739b227e16.jpeg',
    ],
    features: [
      'Available sizes: ID, A5, A4, A3',
      'Thickness options: 80, 125, 250 micron',
      'Crystal clear transparency',
      'Compatible with all thermal laminators',
      'Glossy finish for professional look',
    ],
    specifications: {
      'Sizes Available': 'ID, A5, A4, A3',
      'Thickness Options': '80, 125, 250 Micron',
      Finish: 'Glossy',
      Type: 'Thermal',
      Quality: 'Premium Grade',
    },
  },
  {
    id: 'lamination-machine',
    category: 'lamination-machine',
    icon: 'ri-tools-line',
    name: 'Lamination Machine',
    description:
      'Professional laminating machines for office and commercial use. Supports hot and cold lamination. Available in A4 and A3 sizes with 4-roller system for bubble-free results and adjustable temperature control.',
    suitableFor: ['Retailer', 'Corporate'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/c85b0a2406cbda221cc942de93353936.png',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/0eef544e251c6914d5b4277d21fe7198.png',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/3d52095dc197aeba8420903bb4988074.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/1dcaae2171e7e4fa9df17390d9649c99.jpeg',
    ],
    features: [
      'Available in A4 and A3 sizes',
      'Hot and cold lamination modes',
      '4-roller system for professional results',
      'Adjustable temperature control',
      'Fast warm-up time: 3-5 minutes',
    ],
    specifications: {
      'Sizes Available': 'A4, A3',
      'Max Pouch Thickness': '250 Micron',
      'Roller System': '4 Rollers',
      'Temperature Range': '80°C - 160°C',
      Speed: '300mm/min',
    },
  },
  {
    id: 'glossy-photo-paper',
    category: 'glossy-photo-paper',
    icon: 'ri-image-line',
    name: 'Glossy Photo Paper',
    description:
      'Premium high-gloss photo paper for professional photo printing. Available in various sizes and GSM weights. Instant dry coating prevents smudging. Compatible with all inkjet printers for lab-quality photos.',
    suitableFor: ['Retailer', 'Service Center'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/1e2a9d028998619d677c0653090bade7.png',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/2871a8a526bf7fb8d42e2c68dec59bef.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/2126fd7b9f32d16624d78b2f361fa6f2.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/75d0105a2f7730076ae7bc128c1be809.jpeg',
    ],
    features: [
      'Available sizes: 4x6, A4, A3',
      'Weight options: 130gsm, 150gsm, 180gsm, 230gsm, 260gsm',
      'Instant dry coating prevents smudging',
      'Compatible with all inkjet printers',
      'High gloss finish for vibrant colors',
    ],
    specifications: {
      'Sizes Available': '4x6, A4, A3',
      'Weight Options': '130gsm, 150gsm, 180gsm, 230gsm, 260gsm',
      Finish: 'High Gloss',
      Compatibility: 'All inkjet printers',
      Quality: 'Premium Grade',
    },
  },
  {
    id: 'printer-parts',
    category: 'printer-parts',
    icon: 'ri-settings-3-line',
    name: 'Printer Parts',
    description:
      'Replacement parts and accessories for HP, Canon, Brother, and Samsung printers. Includes fuser units, pickup rollers, maintenance kits, and other essential components. Extends printer life and maintains print quality.',
    suitableFor: ['Service Center', 'Wholesaler'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/44edbf40c6adecd49b829614c2aed88f.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/21ad1ae98432349f86ca9320a287af54.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/113d3d7b3f7d2cb7638f26ba1e6526e4.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/2b0e1b534f2ab315b8c690da19a45e65.jpeg',
    ],
    features: [
      'Compatible with HP, Canon, Brother, Samsung printers',
      'Fuser units, pickup rollers, maintenance kits',
      'High-quality replacement components',
      'Easy installation',
      'Extends printer lifespan',
    ],
    specifications: {
      'Compatible Brands': 'HP, Canon, Brother, Samsung',
      'Parts Available': 'Fuser Units, Rollers, Maintenance Kits',
      Quality: 'OEM Equivalent',
      Type: 'Replacement Parts',
    },
  },
  {
    id: 'inkjet-pvc-card',
    category: 'inkjet-pvc-card',
    icon: 'ri-bank-card-line',
    name: 'Inkjet PVC Card',
    description:
      'Premium blank PVC cards for ID card printing. Standard CR80 size (credit card size). Compatible with Epson and Canon inkjet printers. High-gloss finish for professional-looking ID cards, membership cards, and badges.',
    suitableFor: ['Retailer', 'Corporate'],
    availability: 'In Stock',
    images: [
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/ee003339b93e30858eebefd5c48777f5.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/cf0579e2287a4e2fa2f6a2997faa92f0.jpeg',
      'https://static.readdy.ai/image/a63ec0b6f34fb9b66d50256c348ce6a2/d80ea7fd35aee189e482387148e1e8ce.jpeg',
      'https://public.readdy.ai/ai/img_res/21d79db1714130fbbcfeb3a4eb6e5cd1.jpg',
    ],
    features: [
      'Standard CR80 size (85.6mm x 54mm)',
      'Compatible with Epson L800, L805, Canon iP7270',
      'High-gloss finish for vibrant prints',
      'Waterproof and durable',
      'Available in pack of 230 Pcs in a Box',
    ],
    specifications: {
      Size: 'CR80 (85.6mm x 54mm)',
      Thickness: '0.80mm',
      Finish: 'High Gloss',
      Material: 'PVC',
      Compatibility: 'Epson, Canon inkjet printers',
    },
  },
];
